/** @format */
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { Attainment, DegreeProgramme, OtmId } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { PLAN_ACTIONS_SERVICE_INJECTION_TOKEN, PlanActionsService } from '../../plan/plan-actions-service/plan-actions.service';
import { ModuleStateObject, PlanData, PlanStateObject } from '../../service/plan-state.service';
import { Action, InputType } from '../../study-boxes/study-action-box/study-action-box.component';
import { StudyBoxType } from '../../study-boxes/study-box/study-box.component';

@Component({
    selector: 'sis-plan-structure-degree-programme-box',
    templateUrl: './plan-structure-degree-programme-box.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanStructureDegreeProgrammeBoxComponent implements OnChanges {
    @Input({ required: true }) module: DegreeProgramme;
    @Input({ required: true }) headingLevel: number;
    @Input({ required: true }) planStateObject: PlanStateObject;
    @Input({ required: true }) planData: PlanData;
    @Input() selected?: boolean;
    @Input() action?: Action;
    @Input() actionInputId: string;
    @Input() actionInputName: string;
    @Input() inputType?: InputType;
    @Input() nameClickable?: boolean = true;
    @Output() actionChange? = new EventEmitter<OtmId>();

    attainment: Attainment;
    moduleStateObject: ModuleStateObject;
    boxType: StudyBoxType = StudyBoxType.degreeProgramme;
    studyState: 'DRAFT' | 'DELETED';
    invalidSelection: boolean;
    planActionsService: PlanActionsService = inject(PLAN_ACTIONS_SERVICE_INJECTION_TOKEN);

    ngOnChanges(changes: SimpleChanges) {
        this.moduleStateObject = _.get(this.planStateObject?.modules, this.module.id);
        if (this.moduleStateObject) {
            this.attainment = this.planData.attainmentsById[this.moduleStateObject.attainmentId];
            this.invalidSelection = this.moduleStateObject.invalidSelection && !this.moduleStateObject.hasModuleContentApproval;
        }
        if (this.module.documentState !== 'ACTIVE') {
            this.studyState = this.module.documentState;
        }
    }

    openDegreeProgrammeInfoModal() {
        this.planActionsService.openModuleInfoModal(this.module);
    }
}
